export const shoppingStateFor = (data) => {
  if (data.groups?.some((group) => group.error)) return "partial";
  return data.products?.length ? "ready" : "empty";
};
